import * as React from 'react';
import { SVGProps } from 'react';

const FileIconMp3SizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 21 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M19.6 0H1.4A1.4 1.4 0 0 0 0 1.4v25.2A1.4 1.4 0 0 0 1.4 28h18.2a1.4 1.4 0 0 0 1.4-1.4V1.4A1.4 1.4 0 0 0 19.6 0Z" />
    <path
      opacity={0.7}
      fillRule="evenodd"
      clipRule="evenodd"
      d="m15 12-7 2v8H6.5a1.5 1.5 0 0 0 0 3H7a2 2 0 0 0 2-2v-5.25l5-1.5V20h-1.5a1.5 1.5 0 0 0 0 3h.5a2 2 0 0 0 2-2v-9Zm-1 2.25-5 1.5v1l5-1.5v-1Z"
      fill="#fff"
    />
    <path
      d="M17.5 7.42c0 .553-.134.957-.403 1.21-.268.247-.704.37-1.308.37H14.5V8h1.26c.255 0 .44-.057.56-.17.12-.12.18-.307.18-.56v-.55c0-.22-.066-.393-.2-.52a.715.715 0 0 0-.53-.2h-.958V5h.977a.733.733 0 0 0 .523-.2.696.696 0 0 0 .211-.53v-.55c0-.253-.06-.437-.18-.55-.115-.113-.3-.17-.554-.17H14.5V2h1.168c.57 0 1 .127 1.288.38.296.247.443.64.443 1.18v.63c0 .513-.184 1.05-.553 1.31.436.24.654.65.654 1.23v.69Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3 4v.24c.207-.16.473-.24.8-.24h.7c.587 0 1.017.127 1.29.38.273.247.41.653.41 1.22v1.8c0 .56-.14.967-.42 1.22-.273.253-.7.38-1.28.38h-1.29v2H9.5V4h.8Zm.85 1c-.22 0-.383.06-.49.18a.53.53 0 0 0-.16.37L10.51 8h1.24c.247 0 .433-.057.56-.17.127-.113.19-.273.19-.48v-1.7c0-.207-.063-.367-.19-.48-.127-.113-.313-.17-.56-.17h-.6Z"
      fill="#fff"
    />
    <path
      d="M5 4c.384 0 .735.144 1 .382a1.5 1.5 0 0 1 2.497 1.026l.003.002V9h-1V5.5a.5.5 0 0 0-1 0V9h-1V5.5a.5.5 0 0 0-1 0V9h-1V4h.8v.173C4.509 4.063 4.747 4 5 4Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconMp3SizeS;
